<!-- <div class="m-333 map-container">
<google-map
    #map
    height="100%"
    width="100%"
    [options]="{ 
        gestureHandling: 'greedy', 
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
        center: { lat: 37.7749, lng: -122.4194 },
        zoom: 10
    }"
    (mapInitialized)="onMapReady($event)">
</google-map>   

<div class="route-planning-controls">
  
<div [ngClass]="{'route-ctrls': isPlanningRoute}">
  @if (isPlanningRoute) {
    <button mat-raised-button 
            color="accent"
            [disabled]="currentRoute.length === 0"
            (click)="openRouteInGoogleMaps()">
      <mat-icon>map</mat-icon>
      Open Route ({{ currentRoute.length }})
    </button>

    <button mat-raised-button 
            color="primary"
            [disabled]="currentRoute.length === 0"
            (click)="shareRoute()">
      <mat-icon>share</mat-icon>
      Share
    </button>

    <button mat-raised-button 
            color="warn"
            [disabled]="currentRoute.length === 0"
            (click)="clearRoute()">
      <mat-icon>delete</mat-icon>
      Clear
    </button>
  }
  <button mat-raised-button 
          [color]="isPlanningRoute ? 'accent' : 'primary'"
          (click)="toggleRoutePlanning()">
    <mat-icon>{{ isPlanningRoute ? 'route' : 'directions' }}</mat-icon>
    {{ isPlanningRoute ? 'Exit Route Mode' : 'Plan Route' }}
  </button>
</div>
</div>
</div> -->

<div class="m-333 map-container">
  <google-map
    #map
    height="100%"
    width="100%"
    [options]="{ 
      gestureHandling: 'greedy', 
      mapTypeControl: true,
      streetViewControl: true,
      fullscreenControl: true,
      center: { lat: 37.7749, lng: -122.4194 },
      zoom: 10
    }"
    (mapInitialized)="onMapReady($event)">
  </google-map>   

  <div class="route-planning-controls">
    <div class="route-ctrls">

      <button mat-raised-button 
              color="accent"
              [disabled]="currentRoute.length === 0"
              (click)="openRouteInGoogleMaps()">
        <mat-icon>map</mat-icon>
        Open Route ({{ currentRoute.length }})
      </button>

      <button mat-raised-button 
              color="primary"
              [disabled]="currentRoute.length === 0"
              (click)="sortRoute($event)">
        <mat-icon>reorder</mat-icon>
        Sort Route
      </button>

      <button mat-raised-button 
              color="primary"
              [disabled]="currentRoute.length === 0"
              (click)="shareRoute()">
        <mat-icon>share</mat-icon>
        Share
      </button>

      <button mat-raised-button 
              color="warn"
              [disabled]="currentRoute.length === 0"
              (click)="clearRoute()">
        <mat-icon>delete</mat-icon>
        Clear
      </button>

      <button mat-raised-button 
              class="yards-toggle"
              [class.yards-on]="showYards"
              (click)="toggleYards()"
              [matTooltip]="showYards ? 'Hide yards' : 'Show yards'">
        <mat-icon>warehouse</mat-icon>
        Yards
      </button>

    </div>
  </div>

  <!-- Sort Route Popover -->
  <div class="sort-popover" *ngIf="sortPopoverOpen" #sortPopover>
    <div class="sort-popover-header">
      <span>Sort Route</span>
      <button mat-icon-button (click)="sortPopoverOpen = false">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="sort-popover-list" cdkDropList (cdkDropListDropped)="onRouteDrop($event)">
      <div class="sort-popover-item" 
           *ngFor="let job of currentRoute; let i = index"
           cdkDrag>
        <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
        <span class="sort-index">{{ i + 1 }}</span>
        <span class="sort-label">{{job.jobAddress}}, {{job.jobCity}}, {{job.jobState}}</span>
        <button mat-icon-button color="warn" (click)="removeFromRoute(job)">
          <mat-icon>remove_circle_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>

</div>